import './App.css';
import foodGroupsData from './data/food-groups-data.json';
import SlButton from '@shoelace-style/shoelace/dist/react/button';
import '@shoelace-style/shoelace/dist/themes/light.css';
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path';
import React, { useState } from 'react';
import {
  createBrowserRouter,
  Link,
  RouterProvider,
} from "react-router-dom";

setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.14.0/cdn/');

function Table({data, columns, ratio, dry}) {
  const [sortedData, setSortedData] = useState(data);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  function roundNumber(num, dec) {
    return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
  }
  // key is nutrient id
  const requestSort = (key) => {
    let direction = 'descending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'descending') {
      direction = 'ascending';
    }
    const sortedData = [...data].sort((a, b) => {
      let left = a.foodNutrients.find(el => el.nutrient.id === key);
      let right = b.foodNutrients.find(el => el.nutrient.id === key);
      // Undefined when the food does not define the specified nutrient
      let leftAmount = left !== undefined ? left.amount : 0;
      let rightAmount = right !== undefined ? right.amount : 0;

      if (leftAmount < rightAmount) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (leftAmount > rightAmount) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
    setSortedData(sortedData);
    setSortConfig({ key, direction });
  };

  return (
    <div className="flex overflow-clip gap-0">
      <div>
        <table>
          <thead>
            <tr>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
          {sortedData.map((row, index) => (
              <tr key={"name-" + index}>
                <td><a href={"https://fdc.nal.usda.gov/fdc-app.html#/food-details/" + row.fdcId + "/nutrients"}>{row.displayName}</a></td>
              </tr>
          ))}
          </tbody>
        </table>
      </div>
      <div className="overflow-x-scroll flex-1">
        <table>
          <thead>
            <tr>
              {columns.flatMap((col) => {
                // Hide water if dry
                if (dry && col.id === 1051) {
                  return []
                } else {
                return <th key={col.id} onClick={() => requestSort(col.id)}>
                  {col.name}
                </th>
                }
              })}
            </tr>
          </thead>
          <tbody>
            {sortedData.map((row, index) => (
              <tr key={"data-"+index}>
                {columns.map((value, index) => {
                  // Hide water if dry
                  if (dry && value.id === 1051) {
                    return []
                  }
                  let nutrient = row.foodNutrients.find(el => el.nutrient.id === value.id);
                  if (nutrient === undefined) {
                    return <td key={index}>N/A</td>
                  } else {
                    let dryMultiplier = 1;
                    if (dry) {
                      // Assumes every ingredient specifies water
                      let water = row.foodNutrients.find(el => el.nutrient.id === 1051);
                      dryMultiplier = 100/(100-water.amount);
                    }
                    return <td key={index}>{roundNumber(nutrient.amount*ratio*dryMultiplier,3)} {nutrient.nutrient.unitName}</td>
                  }
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
};

function FoodGroupPage(foodGroupsData, foodGroup) {
  const [quantity, setQuantity] = useState('100');
  const [unit, setUnit] = useState('g');
  const [isValid, setValid] = useState(true);
  const [isDry, setDry] = useState(false);

  function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
           !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  }

  function updateQuantity(newQuantity, newUnit) {
    setQuantity(newQuantity);
    setValid(isNumeric(newQuantity));
    setUnit(newUnit);
  }

  function calculateRatio() {
    if (!isValid) {
      return 1.0;
    }

    const quantityNum = parseFloat(quantity, 10)/100;
    if (unit === 'g') {
      return quantityNum;
    } else {
      return 28.35*quantityNum;
    }
  }

  return (
    <div className="App" key={foodGroup.name}>
      <div>
        {
          foodGroupsData.map((fg) => <Link to={fg.path} className="inline-block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mr-2 rounded-lg focus:outline-none focus:shadow-outline">{fg.name}</Link>)
        }
      </div>
      <input value={quantity} onChange={e => updateQuantity(e.target.value, unit)}/>
      <select value={unit} onChange={e => updateQuantity(quantity, e.target.value)}>
        <option value="g" >g</option>
        <option value="oz">oz</option>
      </select>
      <input type="checkbox" onChange={e => setDry(!isDry)} /> Dry
      {isValid ? <div/>: <div>Error: Not a number</div>}
      <Table data={foodGroup.foods} columns={foodGroup.columns} ratio={calculateRatio()} dry={isDry} />
    </div>
  );
}

function App() {
  let routes = foodGroupsData.map((foodGroup) => ({
      path: foodGroup.path,
      element: FoodGroupPage(foodGroupsData, foodGroup),
    })
  ).concat(
    {
      path: "/",
      element: <div>Welcome!</div>,
    }
  );
  const router = createBrowserRouter(
    routes
  );
  return <RouterProvider router={router} />
}

export default App;

